<template>
  <div>
    <b-row>
      <b-col
        md="8"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <p class="h5 mt-50 mr-75 ml-50">
          일별/월별
        </p>
        <b-form-radio-group
          v-model="query.isPrefixSum"
          @change="changePrefixSum"
        >
          <b-form-radio :value="false">
            일별 (기간:최대1개월)
          </b-form-radio>
          <b-form-radio :value="true">
            월별 (기간:최대1년)
          </b-form-radio>
        </b-form-radio-group>
        <v-date-picker
          v-model="query.startDate"
          type="month"
          value-type="YYYYMM"
          placeholder="조회기간(Fr)"
          class="el-def"
          @change="changeStartDate"
        />
        <label class="ml-50 mr-50">~</label>
        <v-date-picker
          v-model="query.endDate"
          type="month"
          value-type="YYYYMM"
          placeholder="조회기간(To)"
          class="el-def"
        />
      </b-col>
      <b-col
        md="4"
        class="d-flex align-items-center justify-content-end"
      >
        <b-button
          variant="primary"
          class="btn-search"
          @click.prevent="fetchData()"
        >
          조회
        </b-button>
        <b-button
          variant="outline-dark"
          class="btn-search ml-1"
          @click.prevent="excelDownload()"
        >
          <feather-icon
            icon="DownloadIcon"
            class="mr-50"
          />
          <span>엑셀 다운로드</span>
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col
        cols="12"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-table-simple
          bordered
          responsive
          sticky-header
          style="max-height: 65vh;"
        >
          <colgroup>
            <col style="width: 140px">
            <!-- 메디컬트렌드 댓글 작성 -->
            <col style="width: 100px">
            <col style="width: 100px">
            <!-- MY 세미나 등록 -->
            <col style="width: 100px">
            <col style="width: 100px">
            <!-- Weekly Choice 참여 -->
            <col style="width: 100px">
            <col style="width: 100px">
            <!-- 전체 -->
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
            <col style="width: 100px">
          </colgroup>
          <b-thead head-variant="light">
            <b-tr>
              <b-th rowspan="2">
                구분
              </b-th>
              <b-th colspan="2">
                메디컬트렌드 댓글 작성
              </b-th>
              <b-th colspan="2">
                MY 세미나 등록
              </b-th>
              <b-th colspan="2">
                Weekly Choice 참여
              </b-th>
              <b-th colspan="4">
                전체
              </b-th>
            </b-tr>
            <b-tr>
              <b-th style="top: 38.55px;">
                미완료
              </b-th>
              <b-th style="top: 38.55px;">
                완료
              </b-th>
              <b-th style="top: 38.55px;">
                미완료
              </b-th>
              <b-th style="top: 38.55px;">
                완료
              </b-th>
              <b-th style="top: 38.55px;">
                미완료
              </b-th>
              <b-th style="top: 38.55px;">
                완료
              </b-th>
              <b-th style="top: 38.55px;">
                0개완료
              </b-th>
              <b-th style="top: 38.55px;">
                1개완료
              </b-th>
              <b-th style="top: 38.55px;">
                2개완료
              </b-th>
              <b-th style="top: 38.55px;">
                전체완료
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody v-if="data.length > 0">
            <b-tr
              v-for="(m, idx) in data"
              :key="`tr-${idx}`"
            >
              <b-td>{{ m.date }}</b-td>
              <b-td>{{ m.medicalTrendInCompleteCount | $numberFormatter }}</b-td>
              <b-td>{{ m.medicalTrendCompleteCount | $numberFormatter }}</b-td>
              <b-td>{{ m.webSeminarMyInCompleteCount | $numberFormatter }}</b-td>
              <b-td>{{ m.webSeminarMyCompleteCount | $numberFormatter }}</b-td>
              <b-td>{{ m.weeklyChoiceInCompleteCount | $numberFormatter }}</b-td>
              <b-td>{{ m.weeklyChoiceCompleteCount | $numberFormatter }}</b-td>
              <b-td>{{ m.inCompleteCount | $numberFormatter }}</b-td>
              <b-td>{{ m.completeCount1 | $numberFormatter }}</b-td>
              <b-td>{{ m.completeCount2 | $numberFormatter }}</b-td>
              <b-td>{{ m.allCompleteCount | $numberFormatter }}</b-td>
            </b-tr>
          </b-tbody>

          <b-tbody v-else>
            <b-tr>
              <b-td colspan="11">
                <div
                  role="alert"
                  aria-live="polite"
                >
                  <div class="text-center my-2">
                    일치하는 데이터가 없습니다.
                  </div>
                </div>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import axios from '@axios'
import {
  BTableSimple, BThead, BTbody, BTr, BTh, BTd,
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ExcelJS from "exceljs"
import { saveAs } from "file-saver"

export default {
  components: {
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  setup() {
    const data = ref([])

    onMounted(() => {
      fetchData()
    })

    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon

      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }

      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    const changePrefixSum = () => {
      if (query.value.isPrefixSum) {
        query.value.startDate = dayjs().add(-2, 'month').format('YYYYMM')
      } else {
        query.value.startDate = dayjs().format('YYYYMM')
      }

      query.value.endDate = dayjs().format('YYYYMM')
    }

    const query = ref({
      startDate: dayjs().format('YYYYMM'),
      endDate: dayjs().format('YYYYMM'),
      isPrefixSum: false,
    })

    const changeStartDate = value => {
      if (!query.value.isPrefixSum) {
        query.value.endDate = value
      }
    }

    const fetchData = () => {
      const frDate = dayjs(query.value.startDate)
      const toDate = dayjs(query.value.endDate)

      if (query.value.isPrefixSum && Math.abs(frDate.diff(toDate, 'month')) > 11) {
        pushToast('warning', '조회 기간은 최대 1년을 넘을 수 없습니다.')
        return
      }
      if (query.value.isPrefixSum === false && Math.abs(frDate.diff(toDate, 'month')) > 0) {
        pushToast('warning', '조회 기간은 최대 1개월을 넘을 수 없습니다.')
        return
      }

      axios.get('/fa/stats-user-join/mission-complete', {
        params: {
          startDate: frDate.format('YYYY-MM-DD'),
          endDate: toDate.format('YYYY-MM-DD'),
          isPrefixSum: query.value.isPrefixSum,
        },
      })
        .then(rs => {
          data.value = rs.data
        })
        .catch(() => {
          pushToast('danger', '데이터 조회 중 오류가 발생하였습니다.')
        })
    }

    const excelDownload = async () => {
      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet("sheet1")

      worksheet.addRow()

      worksheet.getCell('A1').value = '구분'
      worksheet.mergeCells(`A1:A2`)
      worksheet.getCell('B1').value = '메디컬트렌드 댓글 작성'
      worksheet.mergeCells(`B1:C1`)
      worksheet.getCell('D1').value = 'MY 세미나 등록'
      worksheet.mergeCells(`D1:E1`)
      worksheet.getCell('F1').value = 'Weekly Choice 참여'
      worksheet.mergeCells(`F1:G1`)
      worksheet.getCell('H1').value = '전체'
      worksheet.mergeCells(`H1:K1`)

      worksheet.getCell('B2').value = '미완료'
      worksheet.getCell('C2').value = '완료'
      worksheet.getCell('D2').value = '미완료'
      worksheet.getCell('E2').value = '완료'
      worksheet.getCell('F2').value = '미완료'
      worksheet.getCell('G2').value = '완료'
      worksheet.getCell('H2').value = '0개완료'
      worksheet.getCell('I2').value = '1개완료'
      worksheet.getCell('J2').value = '2개완료'
      worksheet.getCell('K2').value = '전체완료'

      const columns = [
        { key: "date", width: 20 },
        { key: "medicalTrendInCompleteCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "medicalTrendCompleteCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "webSeminarMyInCompleteCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "webSeminarMyCompleteCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "weeklyChoiceInCompleteCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "weeklyChoiceCompleteCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "inCompleteCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "completeCount1", width: 15, style: { numFmt: '#,##0' } },
        { key: "completeCount2", width: 15, style: { numFmt: '#,##0' } },
        { key: "allCompleteCount", width: 15, style: { numFmt: '#,##0' } },
      ]

      worksheet.columns = columns

      // eslint-disable-next-line array-callback-return
      data.value.map(e => {
        const record = {
          date: e.date,
          medicalTrendInCompleteCount: e.medicalTrendInCompleteCount,
          medicalTrendCompleteCount: e.medicalTrendCompleteCount,
          webSeminarMyInCompleteCount: e.webSeminarMyInCompleteCount,
          webSeminarMyCompleteCount: e.webSeminarMyCompleteCount,
          weeklyChoiceInCompleteCount: e.weeklyChoiceInCompleteCount,
          weeklyChoiceCompleteCount: e.weeklyChoiceCompleteCount,
          inCompleteCount: e.inCompleteCount,
          completeCount1: e.completeCount1,
          completeCount2: e.completeCount2,
          allCompleteCount: e.allCompleteCount,
        }

        worksheet.addRow(record)
      })

      worksheet.eachRow({ includeEmpty: true }, (row, number) => {
        row.eachCell({ includeEmpty: true }, cell => {
          if (number === 1 || number === 2) {
            // eslint-disable-next-line no-param-reassign
            cell.font = {
              bold: true,
            }

            // eslint-disable-next-line no-param-reassign
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'D3D3D3' },
            }
          }

          // eslint-disable-next-line no-param-reassign
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          }

          if (cell.value === '소계' || cell.value === '합계') {
            // eslint-disable-next-line no-param-reassign
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'left',
            }
          } else {
            // eslint-disable-next-line no-param-reassign
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'left',
            }
          }
        })
      })

      const mimeType = {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }

      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], mimeType)

      saveAs(blob, "월별미션참여현황.xlsx")
    }

    return {
      data,
      query,
      fetchData,
      changePrefixSum,
      excelDownload,
      changeStartDate,
    }
  },
}
</script>

<style scoped>
.table-bordered th, td {
  border: 1px solid #dee2e6;
}

.table th {
  vertical-align: middle;
}
</style>
